import {
    NJSidebarDeprecated, NJSidebarItemDeprecated, NJSidebarMenuDeprecated, NJTag, NJInlineMessage, NJLink, NJToastContainer, NJToastService, NJButton
} from '@engie-group/fluid-design-system-react';
import { useState, useEffect, useCallback } from 'react';
import { Flex } from "antd";
import './AdminPrompt.css';
import { apiGatewayConfig } from '../../../config';
import { displayNetworkError, invokeLambda } from '../../../api';
import { useOktaAuth } from "@okta/okta-react";
import { useUser } from '../../../context/UserContext';
import Loading from '../../../Loading';


const AdminPrompt = ({ active }) => {

    const userInfo = useUser();
    const { oktaAuth } = useOktaAuth();

    const [promptList, setPromptList] = useState([]);
    const [promptText, setPromptText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [currentPrompt, setCurrentPrompt] = useState(null);
    const [currentPromptId, setCurrentPromptId] = useState(null);
    const [allowEdit, setAllowEdit] = useState(false);

    const handleLoadPromptList = useCallback(async () => {
        // Prepare request
        const request = {
            action: 'load',
        }
        setIsLoading(true);
        try {
            const response = await invokeLambda(oktaAuth, apiGatewayConfig.endpointAdminPromptSystemManagement, request);
            setPromptList(response.promptsystem);
        } catch (error) {
            console.error('Error invoking Lambda:', error);
            displayNetworkError(error);
        } finally {
            setIsLoading(false);
        }
    }, [oktaAuth]);

    useEffect(() => {
        if (active) {
            handleLoadPromptList();
        }
    }, [active, handleLoadPromptList]);

    useEffect(() => {
        if (promptList.length && !currentPromptId) {
            setCurrentPromptId(promptList[0].id);
            setCurrentPrompt(promptList[0])
        }
    }, [promptList, currentPromptId]);

    useEffect(() => {
        if (currentPrompt) {
            setPromptText(currentPrompt.prompt);
        }
    }, [currentPrompt]);

    const handleUpdatePrompt = async (id, prompt) => {
        // Prepare request
        const request = {
            action: 'update',
            id,
            promptsystemobj: {
                prompt: prompt
            }
        }
        setIsLoading(true);
        try {
            await invokeLambda(oktaAuth, apiGatewayConfig.endpointAdminPromptSystemManagement, request, userInfo);
        } catch (error) {
            console.error('Error invoking Lambda:', error);
            displayNetworkError(error);
        } finally {
            setIsLoading(false);
        }
    };

    const onAllowEdit = () => {
        setAllowEdit(true);
    }

    const onSave = async () => {
        await handleUpdatePrompt(currentPromptId, promptText);
        handleLoadPromptList();
    }

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        NJToastService('Copied to clipboard', { iconName: 'check', shouldDismiss: true, dismissAfter: 1000 });
    }

    const isTagInPrompt = (tagLabel) => {
        let found = promptText.toLowerCase().includes(tagLabel.toLowerCase());
        return found;
    };

    const validateMandatoryTags = () => {
        let isValid = true;
        currentPrompt?.required_attributes?.forEach(item => {
            if (!isTagInPrompt(item)) {
                isValid = false;
            }
        });
        return currentPrompt && isValid;
    }

    return (
        <>
            {isLoading && <Loading text="Please wait..." />}
            <NJToastContainer type="full-width" />
            <Flex justify='space-between' style={{ width: '100%' }}>
                <div className='admin-prompt-sidebar'>
                    <div className='admin-prompt-menu'>
                        <NJSidebarDeprecated className='admin-prompt-sidebar-deprecated'>
                            <NJSidebarMenuDeprecated>
                                {promptList?.map((item, index) => {
                                    return (
                                        <NJSidebarItemDeprecated

                                            isActive={currentPromptId === item.id}
                                            key={index}
                                            listItemId={item.id}
                                            onClickItem={(e) => {
                                                setCurrentPromptId(item.id);
                                                setCurrentPrompt(item);
                                                setAllowEdit(false);
                                            }}
                                        >
                                            {item.type}
                                        </NJSidebarItemDeprecated>
                                    )
                                })}
                            </NJSidebarMenuDeprecated>
                        </NJSidebarDeprecated>
                    </div>
                </div>
                <div >
                    <div style={{ width: '2px', backgroundColor: '#ccc', height: '100%' }} />
                </div>
                <div className='admin-prompt-content'>
                    <NJInlineMessage
                        action={<NJLink href="#" variant="high_contrast">Compliance rules</NJLink>}
                        variant="warning"
                    >
                        The system prompt has to be compliant.
                    </NJInlineMessage>
                    <div className='admin-prompt-title1'>
                        Job Ad guidelines prompt
                    </div>
                    <Flex justify='space-between' gap={20} style={{ height: '100%' }}>

                        <div className='admin-prompt-text-column'>
                            <div className='admin-prompt-textarea-container'>


                                <textarea
                                    className='admin-prompt-text'
                                    spellCheck="false"
                                    value={promptText}
                                    onChange={(e) => setPromptText(e.target.value)}
                                    rows="10"
                                    readOnly={!allowEdit}
                                />


                            </div>

                            <Flex justify='flex-end'  >
                                <div className='admin-prompt-buttons'>
                                    {!allowEdit &&
                                        <NJButton
                                            label="Allow Edit"
                                            variant="secondary"
                                            onClick={onAllowEdit}
                                            icon='lock'
                                        />
                                    }
                                    {allowEdit &&
                                        <NJButton
                                            label="Save"
                                            disabled={!validateMandatoryTags()}
                                            onClick={onSave}
                                            icon='save'
                                        />
                                    }
                                </div>
                            </Flex>
                        </div>
                        <div>
                            <div className='admin-prompt-tags-column'>

                                <div className='admin-prompt-tag-block'>
                                    <div className='admin-prompt-title2'>
                                        Prompt mandatory input
                                    </div>
                                    <div className='admin-prompt-tags'>
                                        {currentPrompt && currentPrompt.required_attributes?.map((item, index) => {
                                            return (
                                                <span key={index} className='admin-prompt-tag'>
                                                    <NJTag
                                                        label={item}
                                                        variant={isTagInPrompt(item) ? "green" : "red"}
                                                        onClick={() => copyToClipboard(item)}
                                                    />
                                                </span>
                                            )
                                        })}
                                    </div>
                                </div>

                                {currentPrompt?.optional_attributes?.length &&
                                    <div className='admin-prompt-tag-block'>
                                        <div className='admin-prompt-title2'>
                                            Prompt optional input
                                        </div>
                                        <div className='admin-prompt-tags'>
                                            {currentPrompt && currentPrompt.optional_attributes?.map((item, index) => {
                                                return (
                                                    <span key={index} className='admin-prompt-tag'>
                                                        <NJTag
                                                            label={item}
                                                            variant={isTagInPrompt(item) ? "green" : "red"}
                                                            onClick={() => copyToClipboard(item)}
                                                        />
                                                    </span>
                                                )
                                            })}
                                        </div>
                                    </div>
                                }


                            </div>
                        </div>
                    </Flex>
                </div>
            </Flex>



        </>
    )
}

export default AdminPrompt;